<div class="border rounded-large nordic-blue-300-border border-primary overflow-hidden">
  <div
    class="title grey-100-bg white-text text-icon-reversed ps-medium-x ps-xsmall-y nordic-blue-900-text text-icon-primary"
  >
    {{ title() }}
  </div>
  <div class="content ps-medium-y ps-medium-r">
    <ng-content />
  </div>
</div>
